





























































































































import Vue, { PropType } from "vue";
import PrintType from "@/components/manuscript/PrintType.vue";
import ConfirmationOfTheFinishedImage from "@/components/manuscript/ConfirmationOfTheFinishedImage.vue";
import OrderDetails from "@/components/manuscript/OrderDetails.vue";
import NthOrderAdd from "@/components/NthOrderAdd.vue";
import PrintingPaper from "@/components/PrintingPaper.vue";
import AvailabilityOfOptions from "@/components/AvailabilityOfOptions.vue";
import OrderInformation from "@/components/OrderInformation.vue";
import ProductDeliveryAddress from "@/components/manuscript/ProductDeliveryAddress.vue";
import ProductDeliveryMethod from "@/components/ProductDeliveryMethod.vue";
import PaymentMethod from "@/components/PaymentMethod.vue";
import Questions from "@/components/new/Questions.vue";
import CurrentOrderDetails from "@/components/manuscript/CurrentOrderDetails.vue";
import PrivacyPolicy from "@/components/PrivacyPolicy.vue";
import {
  ManuscriptInterface,
  validationResults
} from "@/model/views/Manuscript.ts";
import { PrintTypeInterface } from "@/model/components/PrintTypeInterface";
import { ConfirmationOfTheFinishedImageInterface } from "@/model/components/ConfirmationOfTheFinishedImageInterface";
import { OrderDetailsInterface } from "@/model/components/manuscript/OrderDetailsInterface";
import { AvailabilityOfOptionsInterface } from "@/model/components/AvailabilityOfOptionsInterface.ts";
import { OrderInformationInterface } from "@/model/components/OrderInformationInterface.ts";
import { ProductDeliveryAddressInterface } from "@/model/components/ProductDeliveryAddressInterface.ts";
import { ProductDeliveryMethodInterface } from "@/model/components/ProductDeliveryMethodInterface.ts";
import { PaymentMethodInterface } from "@/model/components/PaymentMethodInterface.ts";
import { QuestionsInterface } from "@/model/components/new/QuestionsInterface.ts";
import { deliveryMethod } from "@/model/views/display";
import { OrderPrice } from "@/model/price";

export default Vue.extend({
  name: "MInput",

  components: {
    PrintType,
    ConfirmationOfTheFinishedImage,
    OrderDetails,
    NthOrderAdd,
    PrintingPaper,
    AvailabilityOfOptions,
    OrderInformation,
    ProductDeliveryAddress,
    ProductDeliveryMethod,
    PaymentMethod,
    Questions,
    CurrentOrderDetails,
    PrivacyPolicy
  },

  props: {
    formData: {
      type: Object as PropType<ManuscriptInterface>,
      required: true
    },
    orderPrice: {
      type: Object as PropType<OrderPrice>,
      required: true
    }
  },

  computed: {
    siteUrl(): string {
      return process.env.VUE_APP_SITE_URL;
    },
    nth(): Function {
      return (i: number): number => i + 1;
    },
    next(): number {
      return this.formData.orderDetailsList.length + 1;
    },
    isAddableNthOrder(): boolean {
      return this.formData.orderDetailsList.length < 10;
    },
    isBackSideSelected(): boolean {
      return this.formData.printType.backSideColor !== "none";
    },
    isProductionDeliveryMethodShow(): boolean {
      return deliveryMethod(
        this.formData.productDeliveryAddress.deliveryAddress
      );
    }
  },

  methods: {
    // update
    updatePrintType(payload: PrintTypeInterface): void {
      this.$emit("updatePrintType", payload);
    },
    updateConfirmationOfTheFinishedImage(
      payload: ConfirmationOfTheFinishedImageInterface
    ): void {
      this.$emit("updateConfirmationOfTheFinishedImage", payload);
    },
    updateOrderDetails(payload: OrderDetailsInterface, nth: number): void {
      this.$emit("updateOrderDetails", payload, nth);
    },
    updateAvailabilityOfOptions(payload: AvailabilityOfOptionsInterface): void {
      this.$emit("updateAvailabilityOfOptions", payload);
    },
    updateOrderInformation(payload: OrderInformationInterface): void {
      this.$emit("updateOrderInformation", payload);
    },
    updateProductDeliveryAddress(
      payload: ProductDeliveryAddressInterface,
      label: string
    ): void {
      this.$emit("updateProductDeliveryAddress", payload, label);
    },
    updateProductDeliveryMethod(
      payload: ProductDeliveryMethodInterface,
      label: string
    ): void {
      this.$emit("updateProductDeliveryMethod", payload, label);
    },
    updatePaymentMethod(payload: PaymentMethodInterface): void {
      this.$emit("updatePaymentMethod", payload);
    },
    updateQuestions(payload: QuestionsInterface): void {
      this.$emit("updateQuestions", payload);
    },

    // button
    removeNthBtnClick(payload: { nth: number }): void {
      this.$emit("removeNthBtnClick", payload);
    },
    addNthBtnClick(): void {
      this.$emit("addNthBtnClick");
    },
    paperBtnClick(): void {
      this.$emit("paperBtnClick");
    },
    openEmailModalBtnClick(): void {
      this.$emit("openEmailModalBtnClick");
    },
    openSecurityCodeModalBtnClick(): void {
      this.$emit("openSecurityCodeModalBtnClick");
    },
    openFlowImageModalBtnClick(): void {
      this.$emit("openFlowImageModalBtnClick");
    },

    // logic
    validationAll(): boolean {
      /* eslint-disable */
      const r = validationResults;
      const nthOrderErrors = [];
      const t = this as any;
      t.$refs["print-type"].$v.$touch();
      t.$refs["confirmation-of-the-finished-image"].$v.$touch();
      t.$refs["printing-paper"].$v.$touch();
      t.$refs["availability-of-options"].$v.$touch();
      t.$refs["order-information"].$v.$touch();
      t.$refs["product-delivery-address"].$v.$touch();
      t.$refs["product-delivery-method"].$v.$touch();
      t.$refs["payment-method"].$v.$touch();
      t.$refs["questions"].$v.$touch();
      r["printType"] = !t.$refs["print-type"].$v.$invalid;
      r["confirmationOfTheFinishedImage"] = !t.$refs['confirmation-of-the-finished-image'].$v.$invalid;
      r["paper"] = !t.$refs["printing-paper"].$v.$invalid;
      r["availabilityOfOptions"] = !t.$refs["availability-of-options"].$v.$invalid;
      r["orderInformation"] = !t.$refs["order-information"].$v.$invalid;
      r["productDeliveryAddress"] = !t.$refs["product-delivery-address"].$v.$invalid;
      r["productDeliveryMethod"] = !t.$refs["product-delivery-method"].$v.$invalid;
      r["paymentMethod"] = !t.$refs["payment-method"].$v.$invalid;
      r["questions"] = !t.$refs["questions"].$v.$invalid;
      for(let i=1 as number; i<=this.formData.orderDetailsList.length; i++) {
        t.$refs["order-details-" + i][0].$v.$touch()
        nthOrderErrors.push(!t.$refs["order-details-" + i][0].$v.$invalid);
      }
      r["orderDetailsList"] = nthOrderErrors;
      /* eslint-enable */
      let result = true;
      Object.keys(r).forEach(function(key: string) {
        if (key === "orderDetailsList") {
          r["orderDetailsList"].forEach(function(orderDetails: boolean) {
            if (!orderDetails) {
              result = false;
            }
          });
        }
        if (!r[key]) {
          result = false;
        }
      });
      return result;
    }
  }
});
